import React from 'react';
import './grid.scss';
// import Styles from './gridStyle.module.scss';
import Grid from './grid';
import Card from '../Card';
interface GridcontainerProps {
  heading: string;
  rowArray: {
    patchName: {
      name: string;
      image: any;
    };
    remediated: string;
    deviceImpactedTotal: string;
  }[]; // Typing rowArray as an array of objects with specific properties
}
const Gridcontainer: React.FC<GridcontainerProps> = ({ heading, rowArray }) => {
  return (
    <>
      <Card className="flex-1">
        <Grid heading={heading} rowArray={rowArray}></Grid>
        {/* </div> */}
        <style>
          {`
      .ag-center-header-envc .ag-header-cell-label {
        justify-content: center !important;
      }
    `}
        </style>
      </Card>
    </>
  );
};

export default Gridcontainer;
